import PlusPlanCheck from 'assets/pro-plan/plus_check.svg'
import { formatAmount, getCurrencyByLanguage } from 'lib/formatting/amount'
import Row from 'components/elements/Row'
import { parseLocale } from 'lib/constants/localization'
import _useTranslation from 'lib/hooks/_useTranslation'
import { useRouter } from 'next/router'
import { Body2, Body1 } from 'stories/elements/Typography/Text'
import theme from 'stories/utils/theme'
import styled from 'styled-components'
import { getProPlanStripePriceAmount } from '../pro-plan'

const Container = styled.div<{ fullWidth?: boolean }>`
    display: grid;
    gap: 5px;
    width: ${({ fullWidth }) => (fullWidth ? '100%' : '450px')};
    background: linear-gradient(0deg, rgba(10, 10, 10, 0.05), rgba(10, 10, 10, 0.05)),
        linear-gradient(0deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.15));
    border: 3px solid white;
    padding: 10px 20px;
    border-radius: ${theme.borderRadius.webappCard};
    position: relative;
    .interval-row {
        position: relative;
        top: 3px;
    }
    svg {
        position: absolute;
        right: 20px;
        top: 20px;
    }
    @media (max-width: 1050px) {
        width: 100%;
    }
`

interface Props {
    fullWidth?: boolean
}

const PlusPlanPriceLabel = ({ fullWidth }: Props) => {
    const router = useRouter()
    const parsedLocale = parseLocale(router.locale)
    const { t } = _useTranslation('plusPlan')

    const priceAmount = getProPlanStripePriceAmount(parsedLocale)
    const currency = getCurrencyByLanguage(parsedLocale.contentLanguageCode)

    if (!priceAmount || !currency) {
        return null
    }

    return (
        <Container fullWidth={fullWidth}>
            <Body2 fontFamily="var(--font-open-sans)" fontSize={14} color={`${theme.colors.white}cc`}>
                {t('plusPlan/priceCardMonthlyPlanLabel')}
            </Body2>
            <Row gap={5}>
                <Body1 fontSize={18} color={theme.colors.white}>
                    {priceAmount && formatAmount(priceAmount, currency)}
                </Body1>
                <Body2
                    fontFamily="var(--font-open-sans)"
                    color={theme.colors.white}
                    fontWeight={400}
                    className="interval-row"
                >{`/ ${t('plusPlan/intervalYearlyLabel')}`}</Body2>
            </Row>
            <PlusPlanCheck />
        </Container>
    )
}

export default PlusPlanPriceLabel
